import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import ReactDOM from 'react-dom/client';
import './index.css';
import './font.css';
import './i18n'; // i18n 설정 추가
import {PersistGate} from 'redux-persist/integration/react';
import {ThemeProvider} from 'styled-components';
import App from './App';
import ScrollToTop from './component/ScrollToTop';

import reportWebVitals from './reportWebVitals';
import store, {persistor} from './store';
import {theme} from './utils/palette';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ToastContainer
            position="top-right" // 알람 위치 지정
            autoClose={500} // 자동 off 시
          />
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
